import { TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { User } from '@/__generated__/graphql';
import { Order, UsersTableHeadCell } from '@/types';

interface UsersTableHeadProps {
  order: Order;
  orderBy: string;
  headCells: UsersTableHeadCell[];
  onRequestSort: (headerId: keyof User) => void;
}

export const UsersTableHead = ({
  order,
  orderBy,
  headCells,
  onRequestSort,
}: UsersTableHeadProps) => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={() => onRequestSort(headCell.id)}
            >
              <Typography
                fontSize="1.2rem"
                sx={{ fontWeight: 700, color: 'text.primary', textTransform: 'uppercase' }}
              >
                {headCell.label}
              </Typography>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
